import axios from 'axios';
import { BASE_URL } from '../../utils/config/apiConfig';
import { isTokenValid } from './tokenUtils';

/**
 * Axios instance with global config, including automatic JWT injection.
 */
const axiosInstance = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Request interceptor to attach JWT if valid
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (isTokenValid(token)) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to auto-logout on 401
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            // Optional: You can also redirect or trigger Redux logout here
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
